import {hasCookie} from "../lib/utils/cookies";
import {cache} from "../lib/utils/storage";
import {Dropdown} from "./components/dropdown";

export function initValueProp(){
    const el = document.querySelector('#js-value-prop');

    if (el && !hasCookie('uid', document.cookie)){
        el.classList.remove('hidden');
        const mainEl = document.querySelector('main');
        if (mainEl) {
            mainEl.style.paddingTop = '28px';
        }

    }
}

export function headerEffect(){
    const navbar = document.querySelector('.page-header');

    if (navbar && navbar.firstElementChild){
        window.onscroll = function() {
            // pageYOffset or scrollY
            if (window.scrollY > 0) {
                navbar.classList.add('scrolled')
            } else {
                navbar.classList.remove('scrolled')
            }
        }
    }
}

function fixScheduleLink(el: HTMLAnchorElement){
    const categories = cache("fite.cf");
    if (!categories || (categories as string[]).length < 1){
        return
    }

    const url = new URL(el.href);
    url.searchParams.set('categories', (categories as string[]).join(','));
    el.href = url.href;
}

export function initNavData(){
    document.querySelectorAll<HTMLAnchorElement>('a[data-schedule]').forEach((el) => {
        fixScheduleLink(el);
    });
}

export const initHeaderAccountBtn = () => {
    const el = document.getElementById('js-nav-account');

    if (!el){
        return false;
    }

    const links = [
        // {url: "/account/me/", name: "Profile"},
        {url: "/account/info/", name: "Manage Account", classes:"hidden lg:block py-3.5 text-mono-ps-100 hover:text-mono-white"},
        {url: "/account/menu/", name: "Manage Account", classes:"block lg:hidden py-3.5 text-mono-ps-100 hover:text-mono-white"},
        {url: "/account/logout/", name: "Log Out", classes: "block py-3.5 text-mono-ps-100 hover:text-mono-white"}
    ]

    if (hasCookie('eid', document.cookie)) {
        const btnContext = el.dataset;
        if (btnContext && btnContext.profileMenu){
            const elDrop = document.createElement('ul');
            elDrop.setAttribute('id', 'account-options');
            elDrop.setAttribute("class", "hidden absolute top-14 right-4 bg-mono-ns-200 text-center rounded-lg w-52");
            links.forEach(link => {
                const li = document.createElement('li');
                const linkEl = document.createElement('a');
                linkEl.setAttribute("href", link.url);
                linkEl.setAttribute("class", link.classes);
                linkEl.textContent = link.name;
                li.appendChild(linkEl);
                elDrop.appendChild(li);
            })
            el.parentElement?.insertBefore(elDrop, el);
            el.setAttribute("data-dropdown-toggle", "account-options")
            el.setAttribute('href', "#");
            new Dropdown(elDrop, el);
        }
        else if (btnContext && btnContext.urlProfile){
            el.setAttribute('href', btnContext.urlProfile);
        }
        el.querySelector('svg use')?.setAttribute('xlink:href', '#user-profile');
    }else{
        el.setAttribute(
            'href',
            el.getAttribute('href') + `?return_to=${encodeURIComponent(window.location.href)}`
        );
    }
}
